import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import axios from 'axios';
import Breadcrumbs from './Breadcrumbs';

class App extends Component {
  static defaultProps = {
    offset: 1
  }

  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.data?.get_page || 1,
      searchQuery: props.data?.get_query || '',
      products: props.data?.razdel?.products || [],
      pagination: props.data?.razdel?.pagination || null,
      loading: false,
      error: null
    };
  }

  componentDidMount() {
    // Слушаем события браузера (назад/вперед)
    window.addEventListener('popstate', this.handlePopState);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get('page')) || 1;
    const query = urlParams.get('query') || '';
    
    this.setState({ 
      currentPage: page, 
      searchQuery: query 
    });
    this.fetchProducts(page, query, true); // true = не обновлять URL
  }

  // Метод для обновления URL с параметрами
  updateURL(page, query) {
    const url = new URL(window.location.href);
    const baseUrl = url.pathname; // сохраняем базовый путь
    
    if (page > 1) {
      url.searchParams.set('page', page);
    } else {
      url.searchParams.delete('page');
    }
    
    if (query) {
      url.searchParams.set('query', query);
    } else {
      url.searchParams.delete('query');
    }
    
    window.history.pushState({}, '', url);
  }

  // Метод для загрузки товаров
  fetchProducts = async (page, query, skipUrlUpdate = false) => {
    const { data } = this.props;
    const baseUrl = data?.url || window.location.pathname;
    
    this.setState({ loading: true, error: null });
    
    try {
      const response = await axios.get(baseUrl, {
        params: {
          page: page,
          query: query,
          json: 1
        }
      });
      
      if (response.data) {
        this.setState({
          products: response.data?.products || [],
          pagination: response.data?.pagination || null,
          loading: false
        });
        
        // Обновляем URL только если не пропущено
        if (!skipUrlUpdate) {
          this.updateURL(page, query);
        }
      } else {
        this.setState({ 
          products: [], 
          pagination: null,
          loading: false 
        });
      }
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
      this.setState({ 
        error: 'Ошибка загрузки товаров', 
        loading: false 
      });
    }
  }

  handlePageChange = (page) => {
    if (page === '...' || page === this.state.currentPage) return;
    
    this.setState({ currentPage: page });
    this.fetchProducts(page, this.state.searchQuery);
  }

  handleSearch = (e) => {
    if (e.key === 'Enter') {
      const query = e.target.value;
      this.setState({ 
        currentPage: 1, 
        searchQuery: query 
      });
      this.fetchProducts(1, query);
    }
  }

  handleSearchClick = () => {
    const input = document.querySelector('input[placeholder="Например, Азотная кислота"]');
    if (input) {
      const query = input.value;
      this.setState({ 
        currentPage: 1, 
        searchQuery: query 
      });
      this.fetchProducts(1, query);
    }
  }

  renderPagination = () => {
    const { pagination, currentPage, searchQuery } = this.state;
    const baseUrl = this.props.data?.url || window.location.pathname;
    
    if (!pagination || pagination.totalPages <= 1) return null;

    return (
      <div className='w-full mt-[60px] flex items-center justify-center gap-[5px]'>
        {/* Кнопка "Назад" */}
        {pagination.hasPrevPage && (
          <a 
            href={`${baseUrl}?page=${pagination.prevPage}${searchQuery ? `&query=${searchQuery}` : ''}`}
            className='w-[35px] h-[35px] rounded-full bg-[rgba(245,247,249,1)] cursor-pointer flex items-center justify-center hover:bg-[#009EE3] group transition-colors'
            onClick={(e) => {
              e.preventDefault();
              this.handlePageChange(pagination.prevPage);
            }}
          >
            <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75269 0.25L0.577271 5.75L3.75269 11.25" stroke="rgba(3,36,50,0.6)" className="group-hover:stroke-white transition-colors"/>
            </svg>
          </a>
        )}

        {/* Номера страниц */}
        <div className='flex items-center rounded-full bg-[rgba(245,247,249,1)]'>
          {pagination.pages.map((page, index) => (
            page === '...' ? (
              <div 
                key={`dots-${index}`} 
                className='w-[35px] h-[35px] rounded-full cursor-default flex items-center justify-center text-[14px] text-[rgba(3,36,50,0.6)]'
              >
                ...
              </div>
            ) : (
              <a
                key={page}
                href={`${baseUrl}?page=${page}${searchQuery ? `&query=${searchQuery}` : ''}`}
                className={`w-[35px] h-[35px] rounded-full cursor-pointer flex items-center justify-center text-[14px] transition-all no-underline ${
                  currentPage === page 
                    ? 'bg-[#009EE3] text-white' 
                    : 'hover:bg-[#009EE3] hover:text-white text-[rgba(3,36,50,0.6)]'
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  this.handlePageChange(page);
                }}
              >
                {page}
              </a>
            )
          ))}
        </div>

        {/* Кнопка "Вперед" */}
        {pagination.hasNextPage && (
          <a 
            href={`${baseUrl}?page=${pagination.nextPage}${searchQuery ? `&query=${searchQuery}` : ''}`}
            className='w-[35px] h-[35px] rounded-full bg-[rgba(245,247,249,1)] cursor-pointer flex items-center justify-center hover:bg-[#009EE3] group transition-colors'
            onClick={(e) => {
              e.preventDefault();
              this.handlePageChange(pagination.nextPage);
            }}
          >
            <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.433105 0.25L3.60852 5.75L0.433105 11.25" stroke="rgba(3,36,50,0.6)" className="group-hover:stroke-white transition-colors"/>
            </svg>
          </a>
        )}
      </div>
    );
  }

  render() {
    const { offset } = this.props;
    const { products, pagination, loading, error, currentPage, searchQuery } = this.state;

    const data = this.props?.data || {};
    const baseUrl = data?.url || '';

    // Определяем класс для товаров при загрузке
    const productsClass = `grid grid-cols-2 xl:grid-cols-5 gap-[11px] xl:gap-[19px] mt-[20px] transition-opacity duration-300 ${
      loading ? 'opacity-50' : 'opacity-100'
    }`;

    return (
      <div className='mt-[95px] xl:mt-[150px] leading-none'>
        {/* Микроразметка списка товаров/подразделов раздела */}
        {(products.length > 0 || (data?.subcatalog || []).length > 0) &&
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": data?.pagetitle,
              "numberOfItems": products.length > 0
                ? (pagination?.totalItems || products.length)
                : data.subcatalog.length,
              "itemListElement": (products.length > 0 ? products : data.subcatalog).map((elm, index) => ({
                "@type": "ListItem",
                "position": index + 1,
                "url": `https://${data?.helmet?.host || 'himavangard.ru'}/${String(elm?.url || '').replace(/^\//, '')}`,
                "name": elm?.name || elm?.pagetitle
              }))
            })}
          </script>
        }
        <div className='container'>
          {/* Хлебные крошки */}
          <Breadcrumbs breadcrumbs={data?.breadcrumbs} />

          {/* Заголовок */}
          <h1 className='font-medium mt-[30px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>
            {data?.introtext != '' ? Parser(data?.introtext) : data?.pagetitle}
          </h1>

          {data?.subcatalog.length > 0 ?
            <div className='grid grid-cols-2 xl:grid-cols-3 gap-[20px] mt-[20px] overflow-hidden'>
              {(data?.subcatalog || []).map((elm, k) => (
                <a href={elm?.url} key={k} className="group">
                  <div className='flex items-center justify-center overflow-hidden bg-[#F5F7F9] rounded-[15px] w-full h-[271px] xl:h-[271px] relative'>
                    <div className="absolute top-[20px] right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-white flex items-center justify-center text-black text-[16px] xl:text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                      <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <img className='w-auto h-[144px] xl:h-[204px] object-cover' src={elm?.image} alt={elm?.pagetitle} width={306} height={204} />
                  </div>
                  <div className='mt-[14px] text-[16px] xl:text-[18px] tracking-[-0.04em] text-[#032432] leading-none'>
                    {Parser(elm?.pagetitle)}
                  </div>
                </a>
              ))}
            </div>
          :
            <>
              {/* Поиск и скачивание */}
              <div className='mt-[40px] w-full flex flex-col xl:flex-row items-center justify-between gap-[10px]'>
                <div className='bg-[#F5F7F9] rounded-full h-[45px] w-full xl:w-[299px] flex p-[3px] gap-[3px]'>
                  <input 
                    type="text" 
                    placeholder='Например, Азотная кислота' 
                    className='rounded-full text-[14px] pl-[12px] text-[#032432]/60 bg-[#F5F7F9] border-none flex-1 outline-none'
                    onKeyDown={this.handleSearch}
                    defaultValue={searchQuery}
                  />
                  <div 
                    className='flex items-center justify-center w-[39px] h-[39px] rounded-full bg-white cursor-pointer hover:bg-[#009EE3] group transition-colors'
                    onClick={this.handleSearchClick}
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.625 15.75C12.56 15.75 15.75 12.56 15.75 8.625C15.75 4.68997 12.56 1.5 8.625 1.5C4.68997 1.5 1.5 4.68997 1.5 8.625C1.5 12.56 4.68997 15.75 8.625 15.75Z" stroke="black" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors"/>
                      <path d="M16.5 16.5L13.875 13.875" stroke="black" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors"/>
                    </svg>
                  </div>
                </div>
                <a href={data?.catalog_file} target='_blank' className='w-full xl:w-[161px] h-[38px] border-[1px] border-[rgba(3,36,50,0.1)] flex items-center justify-center gap-[5px] rounded-full cursor-pointer hover:bg-[#009EE3] hover:text-white hover:border-[#009EE3] group transition-all'>
                  <div className='text-[#032432] text-[14px] group-hover:text-white transition-colors'>Скачать каталог</div>
                  <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99219 8.75977L8.91219 10.6798L10.8322 8.75977" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors"/>
                    <path d="M8.91016 3V10.6275" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors"/>
                    <path d="M15 9.13477C15 12.4498 12.75 15.1348 9 15.1348C5.25 15.1348 3 12.4498 3 9.13477" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" className="group-hover:stroke-white transition-colors"/>
                  </svg>
                </a>
              </div>

              {/* Ошибка */}
              {error && (
                <div className='mt-[40px] text-center text-red-500 text-[18px]'>
                  {error}
                </div>
              )}

              {/* Сетка товаров */}
              {!error && (
                <>
                  {products.length > 0 ? (
                    <div className={productsClass}>
                      {products.map((product) => (
                        <a 
                          key={product.id} 
                          href={product.url}
                          className="group leading-none tracking-[-0.04em] no-underline"
                        >
                          <div className='flex items-center justify-center overflow-hidden rounded-[15px] w-full h-[210px] xl:h-[271px] relative'>
                            <div className="absolute top-[15px] right-[15px] xl:top-[20px] xl:right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-[#F5F7F9] flex items-center justify-center text-black text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                              <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                              </svg>
                            </div>
                            <img 
                              src={product.img || 'src/images/catalog_img.png'} 
                              alt={product.name} 
                              width={137} 
                              height={192}
                              className="object-contain rounded-[15px] w-full h-auto"
                            />
                          </div>
                          <div className='mt-[14px] text-[16px] xl:text-[18px] text-[#032432] group-hover:text-[#009EE3] transition-colors break-words hyphens-auto'>
                            {product.name}
                          </div>
                          <div className='mt-[10px] text-[16px] xl:text-[18px] text-[#032432]/60'>
                            {Parser(product.title)}
                          </div>
                          <div className='mt-[2px] text-[14px] xl:text-[16px] text-[#032432]/60 break-all'>
                            {Parser(product.text)}
                          </div>
                        </a>
                      ))}
                    </div>
                  ) : !loading && (
                    <div className='mt-[40px] text-center text-[#032432]/60 text-[18px]'>
                      Товары не найдены
                    </div>
                  )}
                </>
              )}

              {/* Навигатор (всегда показываем, даже при загрузке) */}
              {pagination && pagination.totalPages > 1 && this.renderPagination()}

              {/* Информация о количестве товаров */}
              {pagination && pagination.totalItems > 0 && (
                <div className='mt-[20px] text-center text-[14px] text-[#032432]/60'>
                  Показано {products.length} из {pagination.totalItems} товаров
                </div>
              )}
            </>
          }

          {data?.content != '' && (
            <div className='mt-[50px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start page_content'>{Parser(data?.content || ``)}</div>
          )}
        </div>
      </div>
    );
  }
}

export default App;